import { sort_center_api } from '@shared/api';
import {
  AddBagToShipmentHttpResponse,
  AddBagToShipmentManifestHttpRequest,
  CompleteShipmentHttpRequest,
  CompleteShipmentHttpResponse,
  CreateShipmentHttpRequest,
  GetDropOffPointsHttpResponse,
  GetShipmentHttpResponse,
  RemoveBagFromShipmentHttpResponse,
  ShipmentDto,
  ShipmentStatus,
} from '../model/shipment';
import { Filter } from '@uni-space/uni-components';
import { FetchCtx } from '@shared/types/api';
import { PageList } from '@shared/types/filter';
import { makeQueryString } from '@shared/utils/pagging';

export async function getAllShipments(
  page: number | undefined,
  pageSize: number | undefined,
  filters: Filter[] | undefined,
  shipmentStatus: ShipmentStatus,
  ctx?: FetchCtx,
): Promise<PageList<ShipmentDto>> {
  const filter = filters ? [...filters, { name: 'status', value: shipmentStatus }] : filters;
  const url: string = `v1/shipments?` + makeQueryString(page, pageSize, filter);
  const result = await sort_center_api<PageList<ShipmentDto>>(url, { signal: ctx?.signal });
  return result.data;
}

export async function createShipment(data: CreateShipmentHttpRequest): Promise<void> {
  const url = 'v1/shipments';
  await sort_center_api.post(url, data);
}

export async function getDropOffPoints(isReturn: boolean, ctx?: FetchCtx): Promise<GetDropOffPointsHttpResponse> {
  const url = 'v1/drop-off-points';
  const res = await sort_center_api.get<GetDropOffPointsHttpResponse>(url, {
    params: { isReturn },
    signal: ctx?.signal,
  });
  return res.data;
}

export async function addBagToShipment(
  data: AddBagToShipmentManifestHttpRequest,
): Promise<AddBagToShipmentHttpResponse> {
  const url = 'v1/shipments/add-bag';
  const res = await sort_center_api.post<AddBagToShipmentHttpResponse>(url, data);
  return res.data;
}

export async function deleteBagFromShipment(
  data: AddBagToShipmentManifestHttpRequest,
): Promise<RemoveBagFromShipmentHttpResponse> {
  const url = 'v1/shipments/remove-bag';
  const res = await sort_center_api.post<RemoveBagFromShipmentHttpResponse>(url, data);
  return res.data;
}

export async function completeShipment(data: CompleteShipmentHttpRequest): Promise<CompleteShipmentHttpResponse> {
  const url = 'v1/shipments/complete';
  const res = await sort_center_api.post<CompleteShipmentHttpResponse>(url, data);
  return res.data;
}

export async function getShipmentById(shipmentId: number | string): Promise<GetShipmentHttpResponse> {
  const url = `v1/shipments/${shipmentId}`;
  const res = await sort_center_api.get<GetShipmentHttpResponse>(url);
  return res.data;
}

export async function exportShipment(shipmentId: number | string): Promise<void> {
  const url = `v1/shipments/export/${shipmentId}`;
  const res = await sort_center_api.get(url, { responseType: 'blob' });

  const blob = res.data as Blob;
  const blobUrl = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = 'shipment.xlsx';
  link.click();

  window.URL.revokeObjectURL(blobUrl);
}
